import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "name", "type", "description", "content", "downloadLink"]
  
  connect() {
    console.log("Artifact modal controller connected")
  }
  
  show(event) {
    event.preventDefault()
    
    const artifactData = JSON.parse(event.currentTarget.dataset.artifact)
    const artifactId = event.currentTarget.dataset.artifactId
    const projectId = event.currentTarget.dataset.projectId
    
    // Update modal content
    this.nameTarget.textContent = artifactData.name
    this.typeTarget.textContent = artifactData.type
    this.descriptionTarget.textContent = artifactData.description || ''
    
    // Set content or show placeholder
    if (artifactData.content) {
      this.contentTarget.innerHTML = this.renderMarkdown(artifactData.content)
    } else {
      this.contentTarget.innerHTML = `
        <div class="alert alert-info">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="stroke-current shrink-0 w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <span>Content will be generated when you click Generate Artifacts.</span>
        </div>
      `
    }
    
    // Update download link
    this.downloadLinkTarget.href = `/app_projects/${projectId}/meeting_projects/artifacts/${artifactId}/download`
    
    // Show modal
    this.modalTarget.showModal()
  }
  
  close() {
    this.modalTarget.close()
  }
  
  renderMarkdown(content) {
    // For now, just wrap in pre tag - ideally we'd make an AJAX call to render server-side
    // or use a lightweight markdown parser
    return `<pre class="whitespace-pre-wrap">${this.escapeHtml(content)}</pre>`
  }
  
  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}